<template>
  <router-link
    v-if="canAccess"
    v-bind="$attrs"
    :title="title"
    :to="route"
    @click.native="handleHash">
    <slot />
  </router-link>
</template>

<script>
import Link from '../../mixins/Link'
import { doChecks } from '../../../router/authorization'
import { doRouteAuth } from '../../../config'
import { getters } from '../../utils'

export default {
  mixins: [Link],
  props: {
    doIgnoreChecks: Boolean,
  },
  data() {
    return {
      canAccess: true,
    }
  },
  computed: getters(),
  methods: {
    doChecks() {
      if (!doRouteAuth) return
      if (this.doIgnoreChecks) return

      doChecks(this.$route, this.route).catch(() => {
        this.canAccess = false
      })
    },
  },
  watch: {
    isAuth: {
      handler: 'doChecks',
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
</style>
